/* eslint-disable */
import gsap from "gsap";
import LazyLoad from "vanilla-lazyload";
import lottie from "lottie-web";


const HTML = document.querySelector("html");

function sleep(delay) {
  return new Promise((resolve) => setTimeout(resolve, delay))
}

class App {
  constructor() {
    this.lazyload = new LazyLoad({
      unobserve_entered: true,
      elements_selector: ".js-lazy",
      threshold: window.innerHeight * 0.8,
      // eslint-disable-next-line camelcase
      callback_enter: ($el) => {
        if ($el.classList.contains("js-lazy-error-placeholder")) {
          $el.lazyLoadPlaceholder = $el.src;
        } else if ($el.dataset.src == undefined) {
          const figure = $el.closest("figure");
          if (figure) figure.classList.add("img-is-loaded");
        }
      },
      callback_loaded: (el) => {
        const figure = el.closest("figure");
        if (figure) figure.classList.add("img-is-loaded");
      },
      // eslint-disable-next-line camelcase
      callback_error: ($el) => {
        if ($el.lazyLoadPlaceholder) {
          $el.src = $el.lazyLoadPlaceholder;
        }
      },
    });

    this.bodymovin();
    this.cloud();
    this.gridHours();
    this.sliderScreen();
  }

  bodymovin() {
    const tags = document.querySelectorAll("[data-bodymovin]");

    if (tags) {
      tags.forEach((tag) => {
        tag.addEventListener("inview", () => {
          if (!tag.classList.contains("loaded")) {
            const anim = tag.dataset.bodymovin;
            // const path = `${WPTEMPLATE}/static/bodymovin/${anim}/data.json`;
            fetch(anim).then((response) => {
              if (response.status == 200) {
                const l = lottie.loadAnimation({
                  container: tag,
                  renderer: "svg",
                  loop: true,
                  autoplay: true,
                  path: anim,
                });
                tag.classList.add("loaded");
                tag.lottie = l;
              }
            });
          } else if (tag.lottie) {
            tag.lottie.play();
          }
        });

        tag.addEventListener("outview", () => {
          if (tag.lottie) {
            tag.lottie.pause();
          }
        });
      });
    }
  }


  cloud() {
    const clouds = document.querySelectorAll("[data-cloud]");

    if (clouds) {
      clouds.forEach((cloud) => {
        const bound = cloud.getBoundingClientRect();
        const wW = window.innerWidth;
        const tl = gsap.timeline({ paused: true, repeat: -1 });
        const { x, width } = bound;
        const duration = 20 * cloud.dataset.cloud;

        if (cloud.dataset.cloud > 0) {
          const distance1 = wW - x;
          const distance2 = -x - width;
          const total = Math.abs(distance1) + Math.abs(distance2);

          tl.to(cloud, {
            duration: Math.abs((distance1 / total) * duration),
            x: distance1,
            ease: "none",
          })
            .set(cloud, { x: distance2 })
            .to(cloud, {
              duration: Math.abs((distance2 / total) * duration),
              x: 0,
              ease: "none",
            });
        }

        tl.play();
      });
    }
  }

  async sliderScreen() {
    const elts = document.querySelectorAll('.app-slider-screen')

    if( elts ) {
      elts.forEach(slider => {
        let timerSlider = 0;
        let current = -1;

        gsap.set(document.querySelector('html'), {
          background : '#FFF'
        })

        // window.addEventListener('resize', () => {
        //   if(window.innerWidth < 1920) {
        //     gsap.set(slider, {
        //       width : '1920px',
        //       height: '1080px',
        //       position: 'fixed',
        //       top: '50%',
        //       left: '50%',
        //       y : '-50%',
        //       x : '-50%',
        //       scale : window.innerWidth / 1920
        //     })
        //   }
        // })
        // window.dispatchEvent(new Event('resize'))

        /** DEBUG */
        const debugSelect = document.querySelector('.select-slides');
        if( debugSelect ) {
          debugSelect.addEventListener('change', () => {
            goto(parseInt(debugSelect.value), false);
          })
        } 
        window.addEventListener('keyup', (e) => {
          if(e.key == 'd') {
            if( HTML.classList.contains('show-debug') ) {
              HTML.classList.remove('show-debug');
              goto(current);
            } else {

              clearTimeout(timerSlider);
              // Show select
              HTML.classList.add('show-debug');
            }
          }
        })

        /** MESSAGES */
        let isPushShow = false;
        const data = { action : 'screen_msg'};
        const ajaxurl = slider.dataset.ajaxurl;
        // const transitionPush = lottie.loadAnimation({
        //   container: document.querySelector('.animation-push'),
        //   renderer: "svg",
        //   loop: false,
        //   autoplay: false,
        //   path: templateURI + '/static/bodymovin/push.json',
        // });

        async function showMsg() {
          const response = await fetch(ajaxurl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Cache-Control': 'no-cache',
            },
            body: new URLSearchParams(data),
          })
          const output = await response.json();

          if( output.success && output.data ) {
            const data = output.data;

            // Check msg push
            const msgPush = slider.querySelector('.msg-push');
            if( msgPush ) {
              if( data.msg_push.display && data.msg_push.msg && data.msg_push.msg != '') {
                if( data.msg_push.title != '' )
                  msgPush.querySelector('.title').innerHTML = `<h4>${data.msg_push.title}</h4>`;
                else 
                  msgPush.querySelector('.title').innerHTML = '';
                
                msgPush.querySelector('.desc').innerHTML = `${data.msg_push.msg}`;
                await sleep(200);
                msgPush.classList.add('show')
                // if( !isPushShow ) {
                  await sleep(100);
                  // transitionPush.stop();
                  // transitionPush.play();
                // }

                isPushShow = true;

              } else {
                msgPush.classList.remove('show')
                isPushShow = false;
              }
            }

            // Check msg alert
            const msgAlert = slider.querySelector('.msg-alert');
            if( msgAlert ) {
              if( data.msg_alert.display && data.msg_alert.msg && data.msg_alert.msg != '') {
                msgAlert.querySelector('.desc').innerHTML = data.msg_alert.msg;
                await sleep(200);
                msgAlert.classList.add('show')
                clearTimeout(timerSlider);
              } else {
                if( msgAlert.classList.contains('show')) {
                  goto(current < 0 ? 0 : current);
                }
                msgAlert.classList.remove('show')
              }
            }
          }

          await sleep(5000);
          showMsg();
        }
        showMsg();

        /** SLIDER */
        const popupStart = slider.querySelector('.popup-start');
        const slides = slider.querySelectorAll('.item');
        const transitions = [];
        const colors = ['bleu', 'rose', 'jaune']
        for( let i = 0; i < colors.length; i++) {
          const transitionAnim = lottie.loadAnimation({
            container: document.querySelector('.transition-slider-screen'),
            renderer: "svg",
            loop: false,
            autoplay: false,
            path: templateURI + `/static/bodymovin/transition-${colors[i]}.json`,
            rendererSettings: {
              preserveAspectRatio: 'xMidYMid slice',
            }
          });

          transitions.push(transitionAnim);
        }

        function goto(index, timer = true) {

          const duration = slides[index].dataset.duration;

          if( index == current ) {
            timerSlider = setTimeout(() => {
              const next = index >= slides.length - 1 ? 0 : index + 1;
              goto(next);
            }, duration * 1000)
            return;
          }

          let delay = 0;

          if( current >= 0 ) {
            transitions[current%transitions.length].stop();
            transitions[current%transitions.length].play();

            const currentSlide = slides[current]

            gsap.to(currentSlide, {
              autoAlpha: 0,
              y: '-30%',
              ease : 'expo.in',
              onComplete : () => {
                const video = currentSlide.querySelector('video');
                if( video ) {
                  video.pause();
                }
                
                currentSlide.classList.remove('active');
              }
            })
            delay = 1.3;
          }

          const video = slides[index].querySelector('video');
          if( video ) {
            video.currentTime = 0;
            video.play();
          }
          slides[index].classList.add('active')
          gsap.fromTo(slides[index], 
            {
              y : '30%',
            },
            {
              autoAlpha : 1,
              y: '0%',
              ease : 'expo.out',
              duration: 0.5,
              delay,
              onComplete: () => {
                const next = index >= slides.length - 1 ? 0 : index + 1;
                current = index;
                if( timer ) {
                  timerSlider = setTimeout(() => {
                    goto(next);
                  }, duration * 1000)
                }
              }
            }
          )
        }

        if( popupStart ) {
          const triggerStart = popupStart.querySelector('.start-slider');
          triggerStart.addEventListener('click', e => {
            e.preventDefault();
            gsap.to(popupStart, {
              autoAlpha: 0,
              duration : 0.3,
              onComplete : () => {

                goto(0);
                popupStart.remove();
              }
            })
          })
        } else {
          goto(0);
        }
      })
    }
  }

  gridHours() {
    const elts = document.querySelectorAll('.grid-hours');

    if( elts ) {
      elts.forEach(grid => {
        const start = new Date();
        start.setHours(grid.dataset.start);
        start.setMinutes(0);
        start.setSeconds(0);
        const end = new Date();
        if( grid.dataset.start > grid.dataset.end ) end.setDate(end.getDate() + 1)
        end.setHours(grid.dataset.end);
        end.setMinutes(0);
        end.setSeconds(0);
        let now = new Date();
        const child = grid.querySelector('.grid-full')
        const timer = grid.querySelector('.timer');

        gsap.set(child, {
            marginTop : `${grid.offsetHeight / 2}px`,
            y : `${(now-start) / (end-start) * -100}%`
        })
          
        /** Timer */
        setInterval(() => {
          now = new Date();
          const h = (now.getHours() <= 9 ? '0' : '') + now.getHours();
          const m = (now.getMinutes() <= 9 ? '0' : '') + now.getMinutes();
          const s = (now.getSeconds() <= 9 ? '0' : '') + now.getSeconds();
          timer.innerHTML = `${h}:${m}:${s}`;

          gsap.set(child, {
            marginTop : `${grid.offsetHeight / 2}px`,
            y : `${(now-start) / (end-start) * -100}%`
        })
        })
      })
    }
  }
}

window.addEventListener("DOMContentLoaded", () => {
  new App();
});
